import { CircularProgress, TextField, Typography } from '@mui/material'

import './TrayCaseDetails.scss'
import useTrayCaseDetailsLogic from './TrayCaseDetails.logic'
import SurgeryBox from 'components/molecules/SurgeryBox/SurgeryBox'
import { DatePicker, LocalizationProvider } from '@mui/lab'
import AdapterDayjs from '@mui/lab/AdapterDayjs'
import Select from 'components/molecules/Select/Select'

// Add the onSurgeryChange prop
interface TrayCaseDetailsProps {
  onSurgeryChange?: (surgeryId: string, surgery: any) => void
}

const TrayCaseDetails = ({ onSurgeryChange }: TrayCaseDetailsProps = {}) => {
  const {
    filteredSurgeries,
    isNurse,
    caseInformation,
    loading,
    afterDate,
    beforeDate,
    handleAfterDateChange,
    handleBeforeDateChange,
    surgeonOptions,
    selectedSurgeon,
    surgeonsLoading,
    handleSurgeonFilterChange,
    handleClearSurgeonFilter,
    handleTraySurgeryChange,
    isSurgerySelected,
    isSelectedSurgeryNotInDateRange,
    traySurgery,
  } = useTrayCaseDetailsLogic()

  // Create a wrapper for handleTraySurgeryChange that calls onSurgeryChange if provided
  const handleSurgerySelection = (surgery: any) => {
    if (onSurgeryChange) {
      // If surgery is already selected, we're deselecting it
      if (isSurgerySelected(surgery._id)) {
        onSurgeryChange('', undefined)
      } else {
        onSurgeryChange(surgery._id, surgery)
      }
    } else {
      // Fall back to the original handler if no custom handler is provided
      handleTraySurgeryChange(surgery)
    }
  }

  return (
    <div className="tray-case-details-organism_container">
      <Typography variant="h5">Case Details</Typography>

      <div className="filters_container">
        <div className="row">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="After"
              value={afterDate}
              onChange={(date) => handleAfterDateChange(date as Date)}
              renderInput={(params: any) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Before"
              value={beforeDate}
              onChange={(date) => handleBeforeDateChange(date as Date)}
              renderInput={(params: any) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>

        <Select
          fullWidth
          label="Select Surgeon"
          options={surgeonOptions}
          onClear={handleClearSurgeonFilter}
          onSelect={handleSurgeonFilterChange}
          isLoading={surgeonsLoading}
          selectedValue={selectedSurgeon}
        />
      </div>

      {loading && <CircularProgress className="loader" />}

      <div className="surgery-list_wrapper">
        {isSelectedSurgeryNotInDateRange && traySurgery && (
          <SurgeryBox
            key={traySurgery._id}
            surgery={traySurgery}
            onClick={() => handleSurgerySelection(traySurgery)}
            isSelected={isSurgerySelected(traySurgery._id)}
            isNurse={isNurse}
            caseInformation={caseInformation}
          />
        )}
        {filteredSurgeries.map((surgery) => (
          <SurgeryBox
            key={surgery._id}
            surgery={surgery}
            onClick={() => handleSurgerySelection(surgery)}
            isSelected={isSurgerySelected(surgery._id)}
            isNurse={isNurse}
            caseInformation={caseInformation}
          />
        ))}
      </div>

      {filteredSurgeries.length === 0 && !loading && (
        <Typography variant="subtitle2">
          There are no procedures currently scheduled that match your filter
          criteria
        </Typography>
      )}
    </div>
  )
}

export default TrayCaseDetails
